import React, { memo } from 'react';

export const svgIcon = (svg, displayName = 'SvgIcon') => {
  const Icon = props => React.cloneElement(svg, props);
  const MemoIcon = memo(Icon);

  MemoIcon.displayName = displayName;

  return MemoIcon;
};
